import React from 'react'

const Card = ({ 
              title, text, color = 'text-gray-900', withStarts=true,
              pending = 0, completed = 0, starts = [], isLoading,
              bgColor, description, width='md:max-w-[280px]',
  }) => {

  return (
    <div className={`w-full mb-5 md:mb-0 ${width}  py-8 border border-gray-300 shadow-lg rounded-lg ${bgColor || 'bg-white'} `}>
        <p className='text-lg text-center mb-3'>{title}</p>
        {
          withStarts ?
           <div className='flex items-center justify-center'>
               <h1 className={`text-5xl text-center font-bold mb-3 mt-0 ${color}`}> 
                 { (text || text === 0) ? text : '-'}
               </h1>
               
           </div>
          : <h1 className={`text-5xl text-center font-bold mb-3 mt-2 ${color}`}>{text || '-'}</h1>
        }
        {
                description &&
                <p className='text-md text-center mt-2 text-gray-600'>{description}</p>
               }
    </div>
  )
}

export default Card